// Checks on a bidder's company details that need no outside service (the
// server applies the same ones).

const GSTIN_CHARACTERS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";

// The 15th character of a GSTIN is a check digit over the first 14, so a
// mistyped GSTIN is caught without looking it up anywhere
export const gstinCheckDigit = (gstin) => {
  let sum = 0;
  [...gstin.slice(0, 14)].forEach((character, index) => {
    const product =
      GSTIN_CHARACTERS.indexOf(character) * (index % 2 === 0 ? 1 : 2);
    sum += Math.floor(product / 36) + (product % 36);
  });
  return GSTIN_CHARACTERS[(36 - (sum % 36)) % 36];
};

// the 4th character of a PAN tells who holds it
export const PAN_HOLDER_TYPES = {
  P: "Individual",
  C: "Company",
  H: "Hindu Undivided Family",
  F: "Firm / LLP",
  A: "Association of Persons",
  T: "Trust",
  B: "Body of Individuals",
  L: "Local Authority",
  J: "Artificial Juridical Person",
  G: "Government",
};

export const panHolderType = (pan) => PAN_HOLDER_TYPES[(pan || "")[3]] || null;

// an Indian mobile number as 10 digits (drops +91, 91 or 0 in front),
// or null when it isn't one
export const normalizeMobile = (phone) => {
  const digits = String(phone || "").replace(/[\s-]/g, "");
  const match = digits.match(/^(?:\+91|91|0)?([6-9][0-9]{9})$/);
  return match ? match[1] : null;
};

// the state a GSTIN is registered in, from its first two digits
const GST_STATE_CODES = {
  "01": "Jammu and Kashmir",
  "02": "Himachal Pradesh",
  "03": "Punjab",
  "04": "Chandigarh",
  "05": "Uttarakhand",
  "06": "Haryana",
  "07": "Delhi",
  "08": "Rajasthan",
  "09": "Uttar Pradesh",
  10: "Bihar",
  11: "Sikkim",
  12: "Arunachal Pradesh",
  13: "Nagaland",
  14: "Manipur",
  15: "Mizoram",
  16: "Tripura",
  17: "Meghalaya",
  18: "Assam",
  19: "West Bengal",
  20: "Jharkhand",
  21: "Odisha",
  22: "Chhattisgarh",
  23: "Madhya Pradesh",
  24: "Gujarat",
  25: "Daman and Diu",
  26: "Dadra and Nagar Haveli and Daman and Diu",
  27: "Maharashtra",
  28: "Andhra Pradesh",
  29: "Karnataka",
  30: "Goa",
  31: "Lakshadweep",
  32: "Kerala",
  33: "Tamil Nadu",
  34: "Puducherry",
  35: "Andaman and Nicobar Islands",
  36: "Telangana",
  37: "Andhra Pradesh",
  38: "Ladakh",
};

export const stateOfGstin = (gstin) =>
  GST_STATE_CODES[(gstin || "").slice(0, 2)] || null;

// India Post spells some states differently ("Chattisgarh", "Pondicherry",
// "Andaman & Nicobar Islands"), so compare loosely
const STATE_ALIASES = {
  chattisgarh: "chhattisgarh",
  pondicherry: "puducherry",
};
const stateKey = (state) => {
  const key = String(state || "")
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z]/g, "");
  return STATE_ALIASES[key] || key;
};
export const sameState = (a, b) => stateKey(a) === stateKey(b);
